<template>
  <div class="vb-loader" :class="size !== '' ? 'vb-loader--' + size : ''">

    <svg class="vb-loader__icon" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
    </svg>

    <template v-if="show_timing_slot">
      <slot name="timing">
        <span class="vb-loader__text" v-html="loading"></span>
      </slot>
    </template>

    <slot name="default"></slot>
  </div>
</template>

<script>

export default {
  name: 'loader',
  components: {

  },
  props: {
    text_loading: {
      type: Array,
      default: () => {
        return [
          "👉 <strong>Un attimo di pazienza!</strong><br> Stiamo preparando i contenuti, non chiudere o aggiornare la pagina.",
          "👉 <strong>Ci siamo quasi!</strong><br> Lasciaci lavorare ancora un po', tu rilassati e non toccare nulla 😉",
          "👉 <strong>Promesso, manca pochissimo!</strong><br> Resta sulla pagina, stiamo completando tutto per te ✨",
        ]
      }
    },
    show_timing_slot: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      currentIndex: 0,
      interval: -1
    }
  },

  created() {
  },

  computed: {
    loading() {
      return this.text_loading[this.currentIndex];
    },
  },

  mounted() {
    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.text_loading.length;
    }, 12000);
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
  }

}
</script>

<style lang="scss" scoped>

.vb-loader {
  $this: &;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &--small {
    font-size: $font-size-sm;
  }

  &--large {
    font-size: $font-size-lg;
  }

  &__icon {
    animation: rotate 2s linear infinite;

    // size default
    $size: 1.563rem;
    width: $size;
    height: $size;

    // size small
    @at-root #{$this}--small & {
      $size: 1.25rem;
      width: $size;
      height: $size;
    }

    // size large
    @at-root #{$this}--large & {
      $size: 1.875rem;
      width: $size;
      height: $size;
    }


    & .path {
      stroke: var(--info);
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  &__text{
    margin-top: $grid-gutter-width / 2;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

</style>